import { defineStore } from 'pinia';
import { AppConfigType, LanguageType, LimitDataType, SystemDataType } from 'types/appConfig';
import sysConfig from 'service/sysConfig';
import user from 'service/user';
import HiCache from 'utils/cache';
import XBCache from 'utils/cache';

// interface AppState {
//     appName: string;
//     language: string;
//     languageList: LanguageType[];
//     appConfig: AppConfigType;
//     getOffsetWidth: number;
//     systemData: SystemDataType | null;
//     limitData: LimitDataType | {};
//     globalLoading: boolean;
//     isApp: boolean;
//     i18nProp: any;
//     getService: string;
//     metaTitle?: string;
//     hideMenu?: boolean;
//     openSider?: boolean;
// }

export const useRedAppStore = defineStore('redAppStore', {
    state: () => {
        return {
            appName: 'App Name',
            language: '',
            languageList: [],
            appConfig: null,
            getOffsetWidth: 0,
            systemData: null,
            limitData: {},

            globalLoading: true,
            isApp: false,

            i18nProp: null,
            getService: '',
            metaTitle: '',
            hideMenu: false,
            openSider: true,
        };
    },
    getters: {
        getSystemData: state => state.systemData,
        GetLimitData: state => state.limitData,
        GetOffsetWidth: state => state.getOffsetWidth,
        GetGlobalLoading: state => state.globalLoading,
        GetLanguageList: state => state.languageList,
        getIsApp: state => state.isApp,
        GetService: state => state.getService,
    },
    actions: {
        async handleGetLanguage(language?: string) {
            try {
                const result = await user.getFrontLanguages();
                const { code, data: i18nData } = result;
                // const i18nData = [
                //     {
                //         description: 'Português',
                //         value: 'pt',
                //         isDefault: true,
                //     },
                //     {
                //         description: 'English',
                //         value: 'en',
                //         isDefault: false,
                //     },
                // ];

                this.languageList = i18nData || [];
                if (language) {
                    return (this.language = language);
                }

                if (Array.isArray(i18nData) && i18nData.length > 0) {
                    this.language = (i18nData[0] as LanguageType).value;
                } else {
                    this.language = 'en';
                }
                //
                // if (code === 0 && Array.isArray(i18nData) && i18nData.length > 0) {
                //     this.language = (i18nData[0] as LanguageType).value;
                // } else {
                //     // data.SET_LANGUAGE(i18nData.value);
                //     this.language = 'en';
                // }
            } catch (e) {
                console.log('language: ', e);
            }
        },
        setLanguage(value: string) {
            this.language = value;
            HiCache.setCache('language', value);
            location.reload();
        },
        // 清除缓存数据
        removeSession() {
            HiCache.deleteCache('GameVersionKey');
            HiCache.deleteCache('getConfigVersion');
            localStorage.removeItem('gameLotteryList');
            localStorage.removeItem('gameTypeList');
            localStorage.removeItem('topClickList');
            localStorage.removeItem('systemData');
        },
        // 获取系统配置
        async handleGetSystemData(lang: string) {
            try {
                const res = await sysConfig.getConfigVersion();

                // const getVersion = process.env.getConfigVersion;
                const getVersion = XBCache.getCache('getConfigVersion');

                const version = lang + '_' + res?.data;
                if (version === getVersion) {
                    // this.systemData = process.env.systemData && JSON.parse(process.env.systemData);
                    this.systemData = XBCache.getCache('systemData') && JSON.parse(XBCache.getCache('systemData'));
                    // @ts-ignore
                    this.getService = this.systemData?.customerLink;
                    if (this.systemData) return this.systemData;
                }

                try {
                    const result = await sysConfig.getSysConfig();
                    if (result.code === 0) {
                        const { data } = result;
                        //返回数据统一处理
                        if (data.isUseAppUrl) data.isUseAppUrl = Boolean(data.isUseAppUrl);
                        if (data.isOpenNewCustomer) data.isOpenNewCustomer = Boolean(parseInt(data.isOpenNewCustomer));
                        if (data.isOpenChristmasSkin) data.isOpenChristmasSkin = Boolean(parseInt(data.isOpenChristmasSkin));
                        if (data.isUseAndroidAppUrl) data.isUseAndroidAppUrl = Boolean(data.isUseAndroidAppUrl);
                        if (data.pop_time) data.pop_time = parseInt(data.pop_time);
                        if (data.isRechargeBindBankCard) data.isRechargeBindBankCard = Boolean(parseInt(data.isRechargeBindBankCard));
                        if (data.isPollingPayBank) data.isPollingPayBank = Boolean(parseInt(data.isPollingPayBank));
                        if (data.isOpenPromoPreferential) data.isOpenPromoPreferential = Boolean(parseInt(data.isOpenPromoPreferential));
                        if (data.agentMoneyToMoney) data.agentMoneyToMoney = Boolean(parseInt(data.agentMoneyToMoney));
                        if (data.isShowPreferentialTask) data.isShowPreferentialTask = Boolean(parseInt(data.isShowPreferentialTask));
                        if (data.isShowSuperJackpot) data.isShowSuperJackpot = Boolean(parseInt(data.isShowSuperJackpot));
                        this.systemData = data;
                        this.getService = data?.customerLink;
                        XBCache.setCache('getConfigVersion', version);
                        XBCache.setCache('systemData', JSON.stringify(this.systemData));
                        // process.env.getConfigVersion = version;
                        // process.env.systemData = JSON.stringify(this.systemData);

                        return version;
                    }
                } catch (e) {
                    // console.log('获取配置报错', e);
                    await Promise.reject(e);
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 获取注册限制信息
        async handleGetRegIsShow() {
            try {
                const result = await sysConfig.getRegIsShow({
                    page: 1,
                    rows: 20,
                });
                if (result && result?.code === 0) {
                    this.limitData = result.data;
                }
                return result;
            } catch (e) {}
        },
        setOffsetWidth(data: number) {
            this.getOffsetWidth = data;
        },
        // 获取游戏缓存
        async getGameVersion() {
            try {
                const result = await sysConfig.getGameVersion();
                if (result && result.code === 0) {
                    return result.data;
                }
            } catch (e) {
                await Promise.reject(e);
            }
        },
        // 设置globalLoading
        setGlobalLoading(data: boolean) {
            this.globalLoading = data;
        },

        setIsApp(data: boolean) {
            // console.log('当前是否是App: ', data);
            this.isApp = data;
        },
    },
});
